module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ships/ship-form/ship-form.component.sass
// module id = ./src/app/ships/ship-form/ship-form.component.sass
// module chunks = main